import React, { Component } from "react";
import { withRouter, NavLink } from "react-router-dom";
import { connect } from "react-redux";
import {
  fetchBreederDeliveryRecords,
  pdfGeneratorStatus,
} from "../../actions/medicalRecords";
import { PDFExport } from "@progress/kendo-react-pdf";
import { BASE_URL } from "../../utils/helper";



class CollerInsertView extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    mRecord: {
      Breed: {},
      Pet: {},
      Registration_type: {},
      Breeder: {},
      MedicalRecordMedications: [],
    },
    breederRecord: {},
    bannerDone: "",
    signatureDone: "",
    sending: false,
    filename: "-waybill.pdf"
  };

  componentDidMount() {
    this.props.setClick(this.exportPDF);
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      breederRecord: this.props.breederData,
    });
  };


  exportPDF = async () => {
    var _self = this;
    _self.props.pdfGeneratorStatus(true);

    try {
      await _self.resume.save();
      _self.props.pdfGeneratorStatus(false);
    } catch (e) {
      console.error("Problem", e);
    }
  };


  render() {
    const { breederRecord } = this.state;

    let mRecords = breederRecord.MedicalRecords || false;
    const { petShop, sdate, edate } = this.props;
    let filename = sdate+"-"+edate+"-collar-inserts"
    return (
      <div style={{ position: "absolute", top: "0px", left: "-2500px" }}>
        <PDFExport
          paperSize="A4"
          forceProxy={true}
          proxyURL={BASE_URL + "/public/pet_shop/proxyDownload"}
          keepTogether=".sign"
          fileName={filename}
          proxyTarget="_blank"
          title=""
          subject=""
          keywords=""
          landscape={false}
          forcePageBreak=".page-break"
          ref={(component) => (this.resume = component)}
          margin="0.5cm"
        >          
          <div className=""  style={{width:"565px", margin: "0 auto"}}>
            <div style={{width:"100%",marginBottom:"20px",marginTop:"10px"}}>
                { mRecords ? 
                  mRecords.map(function(mRecord, i){
                    return (
                      <div key={i}>

                        { i % 2 == 0 ? <div style={{clear:'both'}}></div> : ""}
                        
                        <div style={{width: "157px",height: "42.75px", marginTop:"50px", marginLeft: "80px", float: "left"}}>
                          <div style={{marginTop:"10px", borderWidth:"1px",borderStyle: "dashed", fontSize: "8px", width: "100%"}}>
                            <div style={{ padding: "2px",float : "left",borderRight: "1px #000 solid",borderBottom: "1px #000 solid", width: "77.5px", height: "21.375px", lineHeight: 0}}>
                              <strong style={{ fontSize: "7px", lineHeight: 1 }}>BREEDER</strong>
                              <p style={{ fontSize: "8px", lineHeight: 1.4, width: "68px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textTransform: "uppercase" }}>{ breederRecord.breeder}</p>
                            </div>

                            <div style={{margin: 0,padding: "2px",float : "left", borderBottom: "1px #000 solid", width: "77.5px", height: "21.375px", lineHeight: 0}}>
                              <strong style={{ fontSize: "7px", lineHeight: 1 }}>CUSTOMER</strong>
                              <p style={{ fontSize: "8px", lineHeight: 1.4, width: "68px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textTransform: "uppercase" }}>{mRecord.Contract == null ? mRecord.PetShop ? mRecord.PetShop.title : "-" : <div>{mRecord.Contract.Customer.firstname} {mRecord.Contract.Customer.lastname}</div>}</p>
                            </div>
                            <div style={{clear:'both'}}></div>
                            <div style={{margin: 0,padding: "2px",float : "left", borderRight: "1px #000 solid", width: "77.5px", height: "21.375px", lineHeight: 0}}>
                              <strong style={{ fontSize: "7px", lineHeight: 1 }}>BREED</strong>
                              <p style={{ fontSize: "8px", lineHeight: 1.4, width: "68px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textTransform: "uppercase" }}>{ mRecord.Breed.breed_type}</p>
                            </div>

                            <div style={{margin: 0,padding: "2px",float : "left", width: "77.5px", height: "21.375px", lineHeight: 0}}>
                              <strong style={{ fontSize: "7px", lineHeight: 1 }}>PUPPY-ID</strong>
                              <p style={{ fontSize: "8px", lineHeight: 1.4, width: "68px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textTransform: "uppercase" }}>{ mRecord.pet_id}</p>
                            </div>

                            <div style={{clear:'both'}}></div>

                          </div>
                        </div>

                      </div>
                    )
                  })
                  : ""
                }

                <div style={{clear:'both'}}></div>

            </div>
             
          </div>
        </PDFExport>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  petShop: state.petShopReducer,
  user: state.cognito.user,
  data: state,
});

const mapDispatchToProps = (dispatch) => ({
  fetchBreederDeliveryRecords: (sdate, edate) => {
    dispatch(fetchBreederDeliveryRecords(sdate, edate));
  },
  pdfGeneratorStatus: (status) => {
    dispatch(pdfGeneratorStatus(status));
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CollerInsertView)
);
